import React, { useState } from "react";
import { Input, message, Button } from "antd";
import sad from "./assets/sad-face.png";
import happy from "./assets/happy-face.png";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { withRouter } from "react-router-dom";
import instance from "../../store/actions/instance";
import { updateUserProfile } from "../../store/actions/profile";

function Nps(props) {
  const [closed, setClosed] = useState(false);
  const [feedbackVisible, setFeedbackVisible] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [rating, setRating] = useState(null);
  const { t } = props;

  const handleClick = async (rating) => {
    try {
      await instance.post("/nps-rating/", {
        nps_score: rating,
        nps_session_id: props.auth.last_session_id,
        nps_feedback: feedback,
      });
    } catch (err) {
      if (err.response && err.response.status === 403) {
        message.error(t("AccessDeniedMessage"));
      } else {
        message.error(t("SomethingWentWrong"));
      }
    }
    setFeedbackVisible(true);
    setRating(rating);
  };

  const handleFeedbackSubmit = async () => {
    try {
      setClosed(true);
      await instance.post("/nps-rating/", {
        nps_score: rating,
        nps_session_id: props.auth.last_session_id,
        nps_feedback: feedback,
      });
    } catch (err) {
      if (err.response && err.response.status === 403) {
        message.error(t("AccessDeniedMessage"));
      } else {
        message.error(t("SomethingWentWrong"));
      }
    }
    message.success("Thanks for your feedback!");
    setFeedbackVisible(false);
  };

  const npsEmojis = [
    "😡", // 0
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "😍", // 10
  ];

  const getNpsColor = (score) => {
    const hue = (score / 10) * 120; // 0 = red, 120 = green
    return `hsl(${hue}, 70%, 45%)`;
  };

  return (
    <div>
      {props.auth.display_nps && !closed ? (
        <div className="NPSContainer">
          <div className="NPSInput animated">
            <button
              className="NPSInput-Close"
              onClick={() => {
                handleClick(rating);
                setClosed(true);
              }}
            >
              ✕
            </button>
            <div className="NPSInput-Inner">
              {!feedbackVisible ? (
                <>
                  <p className="NPSInput-Message">
                    {t("How likely are you to recommend ordable/?")}
                  </p>
                  <div className="NPSScale">
                    <div className="NPSScale-Values">
                      {[...Array(11).keys()].map((i) => (
                        <div
                          key={i}
                          className="NPSScale-Value"
                          onClick={() => handleClick(i)}
                          style={{
                            color: "#fff",
                            borderStyle: "solid",
                            marginTop: -20,
                          }}
                        >
                          <div style={{ fontSize: 16 }}>{npsEmojis[i]}</div>

                          <div
                            style={{
                              opacity: 1,
                              borderWidth: "1px",
                              borderColor: getNpsColor(i),
                              borderRadius: "8px",
                              color: getNpsColor(i),
                              fontWeight: "bold",
                            }}
                          >
                            {i}
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className="NPSScale-Legend">
                      <div className="NPSScale-Label left">
                        😡
                        <div>{t("Not likely")}</div>
                      </div>
                      <div className="NPSScale-Label right">
                        😍
                        <div>{t("Very likely")}</div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <div className="NPSInput-Feedback">
                  {rating <= 6 ? (
                    <p className="NPSInput-Message">
                      {t("😞 What can we do to improve?")}
                    </p>
                  ) : rating >= 9 ? (
                    <p className="NPSInput-Message">
                      {t("😁 What are we doing well?")}
                    </p>
                  ) : (
                    <p className="NPSInput-Message">
                      {t("🙂 How can we do better?")}
                    </p>
                  )}

                  <Input
                    placeholder={
                      rating <= 6
                        ? t("Enter your feedback")
                        : rating >= 9
                        ? t("Tell us what you liked")
                        : t("How can we improve?")
                    }
                    value={feedback}
                    onChange={(e) => setFeedback(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "8px",
                      borderRadius: "4px",
                      marginBottom: "10px",
                    }}
                  />
                  <Button
                    // className="NPSInput-Submit"
                    onClick={handleFeedbackSubmit}
                    type="primary"
                    disabled={rating <= 6 && feedback == ""}
                  >
                    {t("Submit")}
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    profile: state.profile.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateUserProfile: (profile) => dispatch(updateUserProfile(profile)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(withRouter(Nps)));
